export const CatalogDataFragment = `
    id
    name
    is_default
    is_global
    is_full
    organization_id
    organization {
        id
        name
    }
`
